// extracted by mini-css-extract-plugin
export var copyIcon = "_ss-2";
export var discountCard = "_ss-0";
export var discountCode = "_ss-3";
export var discountContent = "_ss-1";
export var loadingCard = "_ss-4";